import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import RelativeLink from "./common/RelativeLink";
import * as types from "../constants/ComponentConstants";

import redirector from "../util/redirector.js";
import AutoBindComponent from "./common/AutoBindComponent";
import * as aanvraagActions from "../actions/aanvraagActions";
import * as layoutActions from "../actions/layoutActions";
import Button from "./common/Button";
import Section from "./common/Section";
import Fieldset from "./common/Fieldset";
import * as DomainConstants from "../constants/DomainConstants";
const editPageUrl = "aanvraag/";
const pdfUrl = "Home/Print/";


class TestPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);
	}

	componentWillMount() {
		this.props.loadLayout();
		if (this.props.aanvraagId) {
			const aanvraagId = this.props.aanvraagId;
			this.props.loadAanvraag(aanvraagId);
		}
	}

	handleOnGoToAanvraag(type) {
		const clearAanvraag = this.props.clearAanvraag;

		return function () {
			clearAanvraag();
			redirector.goTo('/aanvraag/nieuw/' + type);
		};
	}

	render() {
		const aanvraag = this.props.aanvraag.item;
		const type = this.props.type;
		let dossierButtons = "";

		if (aanvraag) {
			const dossierNaam = aanvraag.naam;

			dossierButtons = (
				<Section title="Test Dossier" color={types.COLOR_BLUE}>
					<Fieldset>
						Het dossier met id '{this.props.aanvraagId}' naam '{dossierNaam}' zit nu in de store, klik op
						een knop naar keuze om een pagina te testen met het ingeladen dossier.
						<br />
						<RelativeLink to="/aanvraag/bevestiging" title="test" className="c-button">Go To
							Aanvraag/Bevestiging</RelativeLink>
						<br />
						-- Add other testLinks here --
					</Fieldset>
				</Section>);
		}
		const aanvraagButtons = (
			<Section title="Test Nieuwe Aanvraag per type" color={types.COLOR_BLUE}>
				<Fieldset>
					<RelativeLink to={"/aanvraag/nieuw"} title="Aanvraag BovenLokaal" className="c-button">Go To
						Aanvraag BovenLokaal</RelativeLink>
					<br />
					<br />
					<RelativeLink to={"/aanvraag/nieuw/"+DomainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_RENOVATIE} title="Aanvraag Topsport" className="c-button">Go To
						Aanvraag Topsport</RelativeLink>					
					<br />
					<br />
					<RelativeLink to={"/simulatiedossier/nieuw/"} title="Simulatie Dossier Bovenlokatiteit Nieuwbouw" className="c-button">Go To
						Simulatie Dossier</RelativeLink>	
					<br />
					<br />
				</Fieldset>
			</Section>);

		return <div>{dossierButtons}{aanvraagButtons}</div>;
	}
}

TestPage.propTypes = {
	aanvraag: PropTypes.object
};

function mapStateToProps(state, ownProps) {
	return {
		aanvraagId: ownProps.params.id,
		aanvraag: state.aanvraag,
		type: ownProps.params.type
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadAanvraag: bindActionCreators(aanvraagActions.loadAanvraag, dispatch),
		clearAanvraag: bindActionCreators(aanvraagActions.clearAanvraag, dispatch),
		loadLayout: bindActionCreators(layoutActions.loadTestPageLayout, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(TestPage);
